import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
// import Stories from './pages/Stories';
import Contact from './pages/Contact';
import ConstellationPage from './pages/ConstellationPage';
import GlobePage from './pages/GlobePage';
import CrosswordPage from './pages/CrosswordPage';
import Header from './components/Header';
import Footer from './components/Footer';

import './App.css';

const App: React.FC = () => {
  return (
    <div className='app'>
      <Router>
        {/* Render the NavBar at the top of all pages */}
        <Header />

        {/* Define Routes for each page */}
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/stories" element={<Stories />} /> */}
          <Route path="/globe" element={<GlobePage />} />
          <Route path="/constellation" element={<ConstellationPage />} />
          <Route path="/crossword" element={<CrosswordPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Router>

      {/* Render the Footer at the bottom of all pages */}
      <Footer />
    </div>
  );
};

export default App;
